export var inputVarientType = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};